<template>
  <div class="container-fluid">
    <div class="contents setting change">
      <tab />
      <b-form @submit="onSubmit">
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-2"
            role="tabpanel"
            aria-labelledby="pills-2-tab"
          >
            <div class="row g-0 table-type header-col">
              <div class="col-sm-4">
                  <span class="required">{{ $t("title.setting.currentpassword") }}</span>
                </div>
                <div class="col-sm-8">
                  <input
                    type="password"
                    name="curpassword"
                    v-model="form.curpassword"
                    required
                  />
              </div>

              <div class="col-sm-4">
                  <span class="required">{{ $t("title.setting.newpassword") }}</span>
                </div>
                <div class="col-sm-8">
                  <input
                    type="password"
                    name="newpassword"
                    v-model="form.newpassword"
                    required
                  />
              </div>

              <div class="col-sm-4">
                <span class="required">{{ $t("title.setting.newpasswordconfirm") }}</span>
              </div>
              <div class="col-sm-8">
                <input
                  type="password"
                  name="newpassword_re"
                  v-model="form.newpassword_re"
                  required
                />
              </div>
            </div>

            <div class="btn-bottom-wrapper">
              <b-button
                size="xl"
                variant="primary"
                :aria-label="$t('button.common.save')"
                type="submit"
                >{{ $t("button.common.save") }}</b-button
              >
            </div>

          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/setting";
import tab from "@/components/setting/Tab";

export default {
  name: "PasswordChange",
  components: {
    tab,
  },
  data() {
    return {
      form: {
        curpassword: "",
        newpassword: "",
        newpassword_re: "",
      },
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();

      if (this.form.curpassword === "") {
        alert(this.$i18n.t('alert.setting.enter_current_password'));
        return false;
      }

      if (this.form.newpassword === "") {
        alert(this.$i18n.t('alert.setting.enter_new_password'));
        return false;
      }

      if (this.form.newpassword !== this.form.newpassword_re) {
        alert(this.$i18n.t('alert.setting.new_password_do not match'));
        return false;
      }

      this.set_ownerchangepwd();
    },
    set_ownerchangepwd() {
      ax.set_ownerchangepwd(this.form, (flag, data) => {
        alert(data.message);
        if (flag) {
          this.form.curpassword = "";
          this.form.newpassword = "";
          this.form.newpassword_re = "";
        } else {
          return false;
        }
      });
    },
  },
};
</script>